import React from 'react';
import { connect } from 'react-redux'
import { Spin } from 'antd';
import { RdfTriplet } from '../../redux/OwlActions';

/** Компонента, отображающая количество заданного типа в графе.
 * 
 * В начале CatalogInGraphCount отображает загрузку, в этот момент запрашивается информация о количестве, 
 * если значение найдено, то отображается найденноей значения, если нет, то отображается 0 */
const Loading = () => <span>(<Spin size="small" />)</span>
const Label = ({value, count}) => {
    const label = parseInt((count)?(count):value);
    return (
        <span>({label})</span>
    )
}
  
class RdfTypeCount extends React.Component {
    state = {
        loaded: false,
        IRI: null,
        value: 0
    };

    componentDidMount() {
        this.makeCount();
    }

    componentDidUpdate(prevProps, prevState) {
        this.makeCount();
    }

    makeCount () {
        if (this.state.loaded) return;
        const {IRI, conditions} = this.props;
        //Здесь происходит пересчёт количества концептов по условиям  и rfilter, conditions
        this.props.dispatch(RdfTriplet.loadRdfTypeCount(IRI, conditions))
            .then ((response) =>{
                //console.log("Done!", response);
                let {count} = response;
                this.setState({loaded: true, value: parseInt(count), IRI});
            })
            .catch(e => { 
                this.setState({loaded: true, value: "?", IRI});
                console.error("Error!", e);
            });
    }

    render(){
        const Component = (this.state.loaded)? Label: Loading;
        return(
            <Component {...this.props} {...this.state}/>
        )
    }
}

function mapStateToProps(state, props) {
    //Значения в store redux
    const {vadms, vset} = state;
    //Параметры, которые могут прийти из настроек
    const {graph, IRI, lang } = props;
    const rGraph = (graph)? graph: vset.graph;
    return {
        graph: rGraph,
        lang: (lang)?lang: vset.lang,
        IRI,
        rfilter: vadms.rfilter,
        conditions: vadms.conditions,
        vset
    };
}

export default connect(mapStateToProps)(RdfTypeCount);